import type { PrivilegeDefinition } from '@/core/be/security/SecurityTypes';
import type { FeatureModule } from '@/core/platform/features/FeatureModule';

export const ExcalidrawPrivilegeIds = {
  create: 'excalidraw:create',
  edit: 'excalidraw:edit',
} as const;

const ExcalidrawPrivileges: PrivilegeDefinition[] = [
  {
    id: ExcalidrawPrivilegeIds.create,
    scope: 'vault',
    feature: 'excalidraw',
    description: 'Create new Excalidraw diagrams.',
  },
  {
    id: ExcalidrawPrivilegeIds.edit,
    scope: 'vault',
    feature: 'excalidraw',
    description: 'Edit existing Excalidraw diagrams.',
  },
];

export class ExcalidrawFeatureModule {
  private static readonly definition: FeatureModule = {
    name: 'excalidraw',
    privileges: ExcalidrawPrivileges,
  };

  private constructor() {}

  public static getDefinition(): FeatureModule {
    return ExcalidrawFeatureModule.definition;
  }
}
